import React from 'react';
import { RootState } from '@Common/models/redux/store';
import { useSelector } from 'react-redux';

export enum ABExperiments {
  gcExplainer_june22 = 'gcExplainer_june22',
  checkoutWithLockIcon = 'checkoutWithLockIcon',
  paymentEnhancements = 'paymentEnhancements',
  sampleExp1 = 'sampleExp1',
  tonality_August2022 = 'tonality_August2022',
  pphrStatsIcon_Aug2022 = 'pphrStatsIcon_Aug2022',
  extensionUpSellModalGC = 'extensionUpSellModalGC',
  extensionUpSellModalPPHR = 'extensionUpSellModalPPHR',
  expertViewScribbr_aug22 = 'expertViewScribbr_aug22',
  premiumCTA_August2022 = 'premiumCTA_August2022',
  unchangedWords_Aug2022 = 'unchangedWords_Aug2022',
  premiumCTASidenav_Aug2022 = 'premiumCTASidenav_Aug2022',
  modesMessaging_Aug2022 = 'modesMessaging_Aug2022',
}

interface IProps {
  experiment: ABExperiments;
  variants: {
    [variantName: string]: React.ReactElement;
  };
  fallback: React.ReactElement;
}

// ABTest Wrapper component which will fallback to the variant if available
export function ABTestWithFallbackCtrl({ experiment, variants, fallback }: IProps) {
  // Tests which user are part of
  const runningABTests = useSelector((state: RootState) => state.common.AbTestExperiments);
  // All AB tests info with fallback
  const ABTestData = useSelector((state: RootState) => state.common.AbTestExperimentsInfo);

  if (!ABTestData && !runningABTests) {
    return fallback || null;
  }

  let fallbackVariantFromABTest;
  if (!runningABTests?.[experiment]) {
    fallbackVariantFromABTest = variants[ABTestData?.[experiment]?.fallBack];
  }

  // Return:
  // Active variant (ie, if user is part of the AB experiment)
  // OR defaultVariant from AB test
  // OR usual fallback from component prop
  return variants[runningABTests?.[experiment]] || fallbackVariantFromABTest || fallback || null;
}

export default ABTestWithFallbackCtrl;
